import { render } from "./CellsView.vue?vue&type=template&id=6f2f1788"
import script from "./CellsView.vue?vue&type=script&lang=js"
export * from "./CellsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__